import React from "react";
import { ArrowRight, ChevronDown } from "lucide-react";

const Hero = () => {
    const scrollTo = (id) =>
        document
            .getElementById(id)
            ?.scrollIntoView({ behavior: "smooth", block: "start" });

    return (
        <section
            data-testid="hero-section"
            className="relative min-h-screen flex items-center overflow-hidden"
        >
            {/* Background image */}
            <div className="absolute inset-0">
                <img
                    src="https://images.pexels.com/photos/6503520/pexels-photo-6503520.jpeg"
                    alt="American flag"
                    className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 hero-overlay" />
            </div>

            {/* Stencil top bar */}
            <div className="absolute top-20 left-0 right-0 z-10 hidden md:block">
                <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
                    <div className="flex items-center gap-4 text-[#ffffff]/80 font-chivo text-[10px] tracking-[0.4em] uppercase">
                        <div className="w-12 h-px bg-[#ffffff]/60" />
                        Established · Louisville, KY
                    </div>
                </div>
            </div>

            <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 w-full pt-28 pb-20">
                <div className="max-w-4xl">
                    <div className="bs-eyebrow bs-fade-up bs-delay-1">
                        Roasted in Honor · Brewed with Purpose
                    </div>
                    <h1
                        data-testid="hero-title"
                        className="font-anton text-6xl sm:text-7xl md:text-8xl lg:text-[10rem] leading-[0.9] uppercase text-white mt-6 bs-fade-up bs-delay-2"
                    >
                        Duty.
                        <br />
                        Honor.
                        <br />
                        <span className="text-[#004466]">Coffee.</span>
                    </h1>
                    <p
                        data-testid="hero-subtitle"
                        className="font-body text-lg md:text-xl text-slate-300 max-w-2xl mt-8 leading-relaxed bs-fade-up bs-delay-3"
                    >
                        Coffee forged for those who answer the
                        call. Built by service. Roasted for the watch. A cup
                        that stands its ground.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 mt-10 bs-fade-up bs-delay-4">
                        <button
                            data-testid="hero-shop-button"
                            onClick={() => scrollTo("products")}
                            className="btn-primary"
                        >
                            Shop Roasts
                            <ArrowRight className="w-4 h-4" />
                        </button>
                        <button
                            data-testid="hero-mission-button"
                            onClick={() => scrollTo("mission")}
                            className="btn-secondary"
                        >
                            Our Mission
                        </button>
                    </div>

                    {/* Stat strip */}
                    <div className="grid grid-cols-3 gap-6 md:gap-12 mt-20 max-w-2xl bs-fade-up bs-delay-4">
                        <Stat number="4" label="Signature Roasts" />
                        <Stat number="15%" label="First Responder Discount" />
                        <Stat number="100%" label="Roasted in the USA" />
                    </div>
                </div>
            </div>

            {/* Scroll cue */}
            <button
                data-testid="hero-scroll-cue"
                onClick={() => scrollTo("mission")}
                className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-slate-400 hover:text-[#ffffff] transition-colors flex flex-col items-center gap-2"
            >
                <span className="font-chivo text-[10px] tracking-[0.32em] uppercase">
                    Stand Ready
                </span>
                <ChevronDown className="w-5 h-5 animate-bounce" />
            </button>
        </section>
    );
};

const Stat = ({ number, label }) => (
    <div className="border-l-2 border-[#ffffff] pl-4">
        <div className="font-anton text-3xl md:text-5xl text-white">
            {number}
        </div>
        <div className="font-chivo text-[10px] md:text-xs tracking-[0.22em] uppercase text-slate-400 mt-1">
            {label}
        </div>
    </div>
);

export default Hero;
